export enum GeneratedReportDownloadType {
    EXCEL = 'excel',
    PDF = 'pdf',
    TEXT = 'txt'
}
